import React from 'react';

const LoadingSpinner = ({ message = "Caricamento dati..." }) => {
  return (
    <div className="match-partite-container">
      <div className="match-partite-loading">
        <div className="match-loading-spinner"></div>
        <p>{message}</p>
      </div>
    </div>
  );
};

export default LoadingSpinner;